'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _Box = require('./Box')

var _Box2 = _interopRequireDefault(_Box)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    })
  } else {
    obj[key] = value
  }
  return obj
}

var mw = function mw(em) {
  return em - 0.01
}

var breakpoints = function breakpoints(props) {
  return {
    xs:
      '@media screen and (max-width: ' + mw(props.theme.breakpoints[0]) + 'em)',
    sm:
      '@media screen and (min-width: ' +
      props.theme.breakpoints[0] +
      'em) and (max-width: ' +
      mw(props.theme.breakpoints[1]) +
      'em)',
    md:
      '@media screen and (min-width: ' +
      props.theme.breakpoints[1] +
      'em) and (max-width: ' +
      mw(props.theme.breakpoints[2]) +
      'em)',
    lg:
      '@media screen and (min-width: ' +
      props.theme.breakpoints[2] +
      'em) and (max-width: ' +
      mw(props.theme.breakpoints[3]) +
      'em)',
    xl: '@media screen and (min-width: ' + props.theme.breakpoints[3] + 'em)'
  }
}

var hidden = function hidden(key) {
  return function(props) {
    return props[key]
      ? _defineProperty({}, breakpoints(props)[key], { display: 'none' })
      : null
  }
}

var Hide = _Box2.default.extend(
  [],
  hidden('xs'),
  hidden('sm'),
  hidden('md'),
  hidden('lg'),
  hidden('xl')
)

Hide.displayName = 'Hide'

Hide.propTypes = {
  xs: _propTypes2.default.bool,
  sm: _propTypes2.default.bool,
  md: _propTypes2.default.bool,
  lg: _propTypes2.default.bool,
  xl: _propTypes2.default.bool
}

Hide.defaultProps = {
  theme: _theme2.default
}

exports.default = Hide



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Hide.js
// module id = 56
// module chunks = 35783957827783 64691314399603 114276838955818 228131777832141